<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>
        Olá! Vamos observar o seu coeficiente de desempenho comportamental e
        técnico (nas perspectivas dos comportamentos e das responsabilidades) em
        conjunto?
      </h2>
    </div>

    <div>
      <h2>Meu CDS</h2>
      <p>
        Na aba <span class="info--text">MEU CDS</span> você visualiza seu
        posicionamento em uma matriz Comportamento X Responsabilidade, onde no
        eixo horizontal está o resultado final do desempenho comportamental (na
        perspectiva dos comportamentos) e no eixo vertical está o resultado final
        do desempenho técnico (na perspectiva das responsabilidades). O CDS,
        assim como suas categorias, é apresentado também por meio do velocímetro
        e da tabela.
      </p>
    </div>

    <div>
      <h2>Importante!</h2>
      <ul>
        <li>
          <p class="text-start">
            <span class="font-weight-medium info--text text-lg-h6">
              O cálculo do Coeficiente de Desempenho do Servidor (CDS) utiliza a
              fórmula:
            </span>
          </p>
        </li>
        <p class="text-center">
          <span class="font-weight-medium error--text text-lg-h6">
            (resultado comportamental x resultado de responsabilidades) / 10
          </span>
        </p>
        <li>
          <p class="text-start font-weight-medium info--text text-lg-h6">
            Para mais esclarecimentos, consulte os normativos do Programa
            disponíveis no site:
            <a href="http://desenvolva.ufc.br" target="_blank">
              desenvolva.ufc.br
            </a>
          </p>
        </li>
        <li>
          <p class="text-start">
            <span class="font-weight-medium info--text text-lg-h6">
              Você pode imprimir todos os resultados na opção baixar PDF
            </span>
          </p>
        </li>
      </ul>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../BaseTutorial';

export default {
  name: 'TutorialCoeficienteDesempenho',

  components: { BaseTutorial },

  data() {
    return {
      steps: ['Introdução', 'Meu CDS', 'Importante'],
    };
  },
};
</script>
